"use client";
import {useState} from "react";
import ArrowLeftIcon from "@heroicons/react/16/solid/ArrowLeftIcon";
import ArrowRightIcon from "@heroicons/react/16/solid/ArrowRightIcon";

export default function ProductSlider(props){

    const {paginatedProducts,children} = props;

    const [page,setPage] = useState(1);


    const handleNextPage = () => {
        if(paginatedProducts.items.length<=page*4) return;

        setPage(page + 1);
    }
    const handlePrevPage = () => {
        if(page===1) return;

        setPage(page - 1);
    }

    return <div className={'product-slider relative'}>

            {paginatedProducts && paginatedProducts?.items && paginatedProducts?.items.length > 4 && <>
                <div className={'product-slider-controls space-x-2 absolute right-0 -top-[3.4rem] lg:block hidden'}>
                    <button type={"button"} aria-label={'Previous'} className={'rounded border border-[#101010] py-4 px-4'} onClick={handlePrevPage}><ArrowLeftIcon className={'w-4 h-4'}/></button>
                    <button type={"button"} aria-label={'Next'} className={'rounded border border-[#101010] py-4 px-4'} onClick={handleNextPage}><ArrowRightIcon className={'w-4 h-4'}/></button>
                </div>
            </>}

           {/* <div className={`overflow-x-hidden`} style={{marginLeft: ((page-1)*-100)+'%'}}>*/}
            <div className={`overflow-x-hidden`} >
                <div className={`w-full overflow-x-scroll  no-scrollbar flex space-x-3  pr-2 lg:pr-0 first:pl-2 md:first:pl-0`}>
                {children && children.filter((child,index) => index >= (page-1)*4 && index < page*4)}
                </div>
            </div>

        </div>;

}